export default {
	featureModeControls: {
		selectFeatureHint:
			"Bitte wählen Sie eine Bohrung / Ausschnitt im Modell, um eine Bearbeitung (Gewinde, Senkung, Gravur usw.) zuzuweisen.",
		differentTypesHint:
			"Mehrere Features können nur zusammen bearbeitet werden, wenn sie vom gleichen Typ sind. (z.B. mehreren runden Ausschnitten ein Gewinde hinzufügen)",
		andCutting: " und Schneiden",
		settingsLabel: "Einstellungen:",
		pleaseSelectTool: "Bitte auswählen...",
		pressJoinCategories: {
			all: "Alle Einpressungen",
			nut: "Einpressmutter",
			threadedStud: "Einpressgewindebolzen",
			threadedBushing: "Einpressgewindebuchsen",
		},
		noToolsForSide: "Für die gewählte Seite stehen leider keine Werkzeuge zur Verfügung",
		noToolsForMaterial: "Für dieses Material steht diese Bearbeitung leider nicht zur Verfügung.",
		apply: "Anwenden",
	},
	featurePanel: {
		minimize: "minimieren",
		groups: {
			screwThread: "Gewinde",
			countersink: "Senkungen",
			extrudedThread: "Durchzüge",
			cylinderHeadBoltHole: "Zylindersenkungen",
			pressJoin: "Einpressungen",
			engraving: "Gravuren",
			hole: "Runde Ausschnitte",
			cutout: "Ausschnitte",
			weldline: "Schweißnähte",
			anchorFace: "Oberseiten",
			bottomFace: "Unterseiten",
			sideFace: "Aussenseiten",
		},
		weldlineStatus: {
			cleaned: "verputzt",
			uncleaned: "unverputzt",
		},
		labels: {
			engraving: "Gravur {id}",
			diameter: "Durchmesser: {value}mm",
			cutout: "Ausschnitt {id}",
			weldline: "Schweißnaht {id}",
			anchorFace: "Oberseite {id}",
			bottomFace: "Unterseite {id}",
			sideFace: "Aussenseite {id}",
			weldlineTitle: "Id {id} - {length} mm",
			weldlineCornerSingular: " + Ecke",
			weldlineCornerPlural: " + Ecken",
		},
		undetermined: "Unbestimmt",
	},
	structurePanel: {
		minimize: "minimieren",
	},
	articlePanel: {
		minimize: "minimieren",
		blexonNumber: "Blexon Nr.:",
		material: "Material:",
		dimensions: "LxBxH:",
		saveAndClose: "Speichern und Schliessen",
		underReview: "In Überprüfung",
		sendToHelpdesk: "An Helpdesk senden",
		additionalDesignation: {
			groundFoil: " / Schliff / Folie",
			foil: " / Folie",
			ribbed: " / Riffeln",
		},
	},
};
